import React, { useEffect } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  Pressable,
} from "react-native";
import BackArrow from "@assets/svg/BackArrow";
import SearchIcon from "@assets/svg/HeaderSearchIcon";
import WhatsappDefault from "@assets/svg/WhatsappDefault";
import { Text as ANText } from "react-native-animatable";
import ArrowDown from "@assets/svg/ArrowDown";
import { useNavigation } from "@react-navigation/native";
import useLeaderState from "@hooks/useLeaderState";
import { useSelector } from "react-redux";

const CategoryHeader = ({
  title = "",
  light = false,
  background,
  shareOnWhatsapp = () => {},
  showWhatsappLogo = true,
  animation = false,
  onTitleClick = null,
  showSearch = true,
  trackEvent = () => {},
  showArrow = false,
}) => {
  const navigation = useNavigation();
  const { canLeaderUseApp } = useLeaderState();
  const shareOnWhatsappRestricted = () => {
    if (!canLeaderUseApp()) {
      return;
    }
    shareOnWhatsapp();
  };
  const cp_db_id = useSelector(({ auth }) => auth?.user?.cp_db_id);
  return (
    <>
      <View style={[styles.container, background]}>
        <TouchableOpacity
          onPress={() => {
            navigation.goBack();
          }}
          hitSlop={{ top: 20, bottom: 15, left: 50, right: 25 }}
        >
          <BackArrow color={light ? "#fff" : "#000"} />
        </TouchableOpacity>
        {!animation || !title ? (
          <Pressable
            onPress={() => {
              if (typeof onTitleClick === "function") {
                onTitleClick();
              }
            }}
            style={{
              flexDirection: "row",
              flex: 1,
              alignItems: "center",
            }}
          >
            <Text
              ellipsizeMode="tail"
              numberOfLines={1}
              style={[
                styles.title,
                {
                  color: light ? "#fff" : "rgba(0, 0, 0, 0.87)",
                  marginRight: 6,
                },
              ]}
            >
              {title}
            </Text>
            {showArrow ? <ArrowDown /> : null}
          </Pressable>
        ) : (
          <ANText
            ellipsizeMode="tail"
            numberOfLines={1}
            animation="slideInUp"
            useNativeDriver={true}
            duration={150}
            style={[
              styles.title,
              { color: light ? "#fff" : "rgba(0, 0, 0, 0.87)", width: "60%" },
            ]}
          >
            {title}
          </ANText>
        )}
        {showWhatsappLogo && (
          <TouchableOpacity
            style={[
              styles.shareContainer,
              {
                backgroundColor: light
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(0, 0, 0, 0.1)",
              },
            ]}
            onPress={shareOnWhatsappRestricted}
          >
            <WhatsappDefault size={26} />
          </TouchableOpacity>
        )}

        {showSearch && !cp_db_id ? (
          <TouchableOpacity
            style={[
              styles.searchContainer,
              {
                backgroundColor: light
                  ? "rgba(255, 255, 255, 0.1)"
                  : "rgba(0, 0, 0, 0.1)",
              },
            ]}
            onPress={() => {
              if (typeof trackEvent === "function") {
                trackEvent();
              }
              navigation.navigate("Search");
            }}
          >
            <SearchIcon strokeWidth="2" fill={light ? "#fff" : "#000"} />
          </TouchableOpacity>
        ) : null}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 15,
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    height: 66,
    overflow: "hidden",
    backgroundColor: "white",
  },
  title: {
    fontWeight: "bold",
    fontSize: 18,
    lineHeight: 30,
    marginLeft: 30,
    // marginRight: "auto",
  },
  shareContainer: {
    height: 36,
    width: 36,
    borderRadius: 999,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 30,
  },
  searchContainer: {
    height: 36,
    width: 36,
    borderRadius: 999,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "auto",
  },
});

export default CategoryHeader;
